export default "__VITE_ASSET__XiwJfVvE__"